import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * There is no separate sign-up any more. Entering an email on /sign-in and
 * verifying the 6-digit code creates the account when the address is new, so
 * this route's old three-step page — name, password, phone, preferences —
 * contradicted the flow the rest of the product runs on. It asked for a
 * password nothing else would ever check.
 *
 * The page component is gone — it was the last thing on the site rendering a
 * native <select>, and dressing four of them for a page no route reaches was
 * not worth it. Nothing links here, and it is noindex, so this only catches an
 * old bookmark or a hand-typed URL.
 */
export const Route = createFileRoute("/sign-up")({
  beforeLoad: () => {
    throw redirect({ to: "/sign-in", statusCode: 301 });
  },
});
